import IContactNotification, { ContactNotificationType } from "@myinnsworth/models/contact/IContactNotification";
import bellIcon from '../../assets/images/bell-icon.svg';
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApplicantType } from "@myinnsworth/models/applicants/IApplicant";
import { contactHttpService, filesHttpService } from "@myinnsworth/httpServices";
import clsx from "clsx";

export interface INotificationListItemProps {
    notification: IContactNotification;
}

export default function NotificationListItem(props: INotificationListItemProps) {
    const [description, setDescription] = useState<string>('');
    const [isRead, setIsRead] = useState<boolean>(props.notification.isRead);

    const nav = useNavigate();

    const onView = async () => {
        //Set notification to read
        try {
            if(!isRead) {
                await contactHttpService.setNotificationAsRead(props.notification.id);
                setIsRead(true);
            }
        } catch {}

        switch(props.notification.type) {
            case ContactNotificationType.ApplicantUpdated: {
                let route = `/cases/${props.notification.case?.slug}/claimant-details`;
                if(props.notification.applicantType === ApplicantType.Institution) {
                    route += `/${props.notification.applicant?.id}/view/index`;
                } else if(props.notification.applicantType === ApplicantType.Fund) {
                    route += `/${props.notification.institution?.id}/view/funds/${props.notification.applicant?.id}/view/index`;
                }
                nav(route);
                break;
            }
            case ContactNotificationType.FileUploaded: {
                const url = await filesHttpService.getViewUrlFromFileId(props.notification.fileId!);
                if(url) {
                    window.open(url, '_blank');
                }
                break;
            }
            case ContactNotificationType.LossReportUpdated: {
                let route = `/cases/${props.notification.case?.slug}/claimant-details`;
                if(props.notification.applicantType === ApplicantType.Institution) {
                    route += `/${props.notification.applicant?.id}/view/index`;
                } else if(props.notification.applicantType === ApplicantType.Fund) {
                    route += `/${props.notification.institution?.id}/view/funds/${props.notification.applicant?.id}/view/index`;
                }
                nav(route);
                break;
            }
            case ContactNotificationType.NewsArticlePublished: {
                const route = `/dashboard/latest-news/${props.notification.newsId!}`;
                nav(route);
                break;
            }
        }
    };

    useEffect(() => {
        let desc = '';

        //Prepend the case name if we have one
        if(props.notification.case) {
            desc += `${props.notification.case.name} - `;
        }

        switch(props.notification.type) {
            case ContactNotificationType.ApplicantUpdated: {
                desc += `Applicant Details`;
                break;
            }
            case ContactNotificationType.FileUploaded: {
                desc += `New File`;
                break;
            }
            case ContactNotificationType.LossReportUpdated: {
                desc += `Updated Loss Report`;
                break;
            }
            case ContactNotificationType.NewsArticlePublished: {
                desc += `News Article Published`;
                break;
            }
        }

        setDescription(desc);
    }, [props.notification]);

    return (<>
        <div className={clsx('notification-item', {'unread': !props.notification.isRead})}>
            <div className="notification-date">
                <img src={bellIcon} alt="Alert Icon" />
                {format(props.notification.created, 'dd/MM/yyyy hh:mm')}
            </div>
            <div className="notification-title">
                {props.notification.createdBy && (<>{props.notification.createdBy.displayName} has updated your case</>)}
                {!props.notification.createdBy && (<>Your case has received an update.</>)}
            </div>
            <div className="notification-description">
                {description}
            </div>
            <div className="actions">
                <button className="btn secondary" onClick={() => onView()}>View</button>
            </div>
        </div>
    </>);
}